//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const POPOVER_WIDTH = 296;
const POPOVER_OFFSET_Y = 12;

export default {
  name: 'AddSessionPopover',

  props: {
    visible: { type: Boolean, default: false },
    triggerEl: { type: [Object, Element], default: null },
    sessionUrl: { type: String, default: '' },
  },

  data() {
    return {
      top: 0,
      left: 0,
      openAbove: false,
      openLeft: false,
    };
  },

  computed: {
    positionStyle() {
      return {
        position: 'fixed',
        top: `${this.top}px`,
        left: `${this.left}px`,
        width: `${POPOVER_WIDTH}px`,
        zIndex: 11000,
      };
    },
  },

  watch: {
    visible(now) {
      if (now) this.attachListeners();
      else this.detachListeners();
    },
    triggerEl() {
      if (this.visible) this.$nextTick(() => this.computePosition());
    },
  },

  beforeDestroy() {
    this.detachListeners();
  },

  methods: {
    computePosition() {
      if (!this.triggerEl) return;
      const r = this.triggerEl.getBoundingClientRect();
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const popW = POPOVER_WIDTH;
      // Read rendered height; fall back to 140 if element not yet in DOM
      const popH = (this.$el && this.$el.offsetHeight) || 140;

      // Vertical: prefer below; flip above when popover clips bottom and more room above
      const spaceBelow = vh - r.bottom - POPOVER_OFFSET_Y;
      const spaceAbove = r.top - POPOVER_OFFSET_Y;
      this.openAbove = spaceBelow < popH && spaceAbove >= popH;

      const top = this.openAbove
        ? r.top - POPOVER_OFFSET_Y - popH
        : r.bottom + POPOVER_OFFSET_Y;

      // Horizontal: right-align to trigger's right edge by default;
      // flip to left-align when right-aligned position clips the left viewport edge
      const rightAligned = r.right - popW;
      this.openLeft = rightAligned < 8;
      const rawLeft = this.openLeft ? r.left : rightAligned;

      this.top = top;
      this.left = Math.max(8, Math.min(vw - popW - 8, rawLeft));
    },

    attachListeners() {
      // $nextTick ensures the element is in the DOM so offsetHeight is readable
      this.$nextTick(() => this.computePosition());
      document.addEventListener('mousedown', this.onOutsideClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('scroll', this.computePosition, true);
      window.addEventListener('resize', this.close);
    },

    detachListeners() {
      document.removeEventListener('mousedown', this.onOutsideClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('scroll', this.computePosition, true);
      window.removeEventListener('resize', this.close);
    },

    onOutsideClick(e) {
      if (!this.$el || !this.$el.contains) return;
      if (this.$el === e.target || (this.$el.contains && this.$el.contains(e.target))) return;
      if (this.triggerEl && this.triggerEl.contains(e.target)) return;
      this.close();
    },

    onKeydown(e) {
      if (e.key === 'Escape') this.close();
    },

    onOpen() {
      if (this.sessionUrl) window.open(this.sessionUrl, '_blank', 'noopener');
      this.close();
    },

    onCancel() { this.close(); },

    close() { this.$emit('close'); },
  },
};
